import { TalentForm } from "@/features/talent/components/talent-form/TalentForm";

export const TalentCreatePage = () => {
  return <TalentForm />;
};
